import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';

import { deleteMapping } from '../../../../../actions/synchronisationActions';
import MappingForm from './MappingForm';

class MappingTable extends Component {
  // The entry MappingForm reports its selected source/target up here (it used to live
  // in redux-form's state.form.mappingForm.values, which no longer exists after the
  // react-hook-form migration). We filter the existing-mappings list by it.
  state = { formFilter: { sourceTable: null, targetTable: null } };

  handleSelectionChange = formFilter => this.setState({ formFilter });

  handleDeleteMapping = mappingId => {
    const { storeId, sourceId, deleteMapping } = this.props;
    return () => {
      deleteMapping(storeId, sourceId, mappingId);
    };
  };

  // A selected source/target in the entry form filters the table (and, as before,
  // takes precedence over the "Show overrides only" filter); otherwise the override
  // filter applies.
  getFilteredMappings() {
    const { mappings, overrideOnly } = this.props;
    const { sourceTable, targetTable } = this.state.formFilter;
    let filtered = mappings || [];
    if (sourceTable || targetTable) {
      if (sourceTable) filtered = filtered.filter(mapping => sourceTable === mapping.sourceTable);
      if (targetTable) filtered = filtered.filter(mapping => targetTable === mapping.targetTable);
      return filtered;
    }
    if (overrideOnly) {
      return filtered.filter(mapping => mapping.isOverride);
    }
    return filtered;
  }

  render() {
    const mappings = this.getFilteredMappings();
    return (
      <Table bordered style={{ marginTop: 10, tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ width: '13%' }}>Source Table</th>
            <th style={{ width: '14%' }}>Source Column</th>
            <th style={{ width: '13%' }}>Target Table</th>
            <th style={{ width: '14%' }}>Target Column</th>
            <th style={{ width: '13%' }}>Default Value</th>
            <th style={{ width: '8%' }}>Row Group</th>
            <th style={{ width: '13%' }}>Converter</th>
            <th style={{ width: '7%' }}>Override</th>
            <th style={{ width: '8%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          <MappingForm
            storeId={this.props.storeId}
            sourceId={this.props.sourceId}
            onSelectionChange={this.handleSelectionChange}
          />
          {mappings &&
            mappings.map((mapping, idx) => (
              <tr key={idx}>
                <td>{mapping.sourceTable}</td>
                <td>{mapping.sourceColumn}</td>
                <td>{mapping.targetTable}</td>
                <td>{mapping.targetColumn}</td>
                <td>{mapping.defaultValue}</td>
                <td>{mapping.rowGroup}</td>
                <td>{mapping.converter}</td>
                <td>{mapping.isOverride ? 'Y' : null}</td>
                <td>
                  {mapping.isOverride && (
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: 'transparent' }}
                      onClick={this.handleDeleteMapping(mapping.id)}
                    >
                      <i className="fa-solid fa-xmark" />
                    </button>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }
}

export default connect(
  state => ({
    mappings: state.sync.mapping.mappings,
    overrideOnly: state.sync.mapping.filter.override
  }),
  dispatch => ({
    deleteMapping: (storeId, sourceId, mappingId) => dispatch(deleteMapping(storeId, sourceId, mappingId))
  })
)(MappingTable);
